import type { AdminActiveEvent } from "../../interfaces/AdminEventProduct";
import { eventDisplayLabel } from "../../utils/eventDisplayName";
import { eventTypeLabel } from "../../utils/eventPortalLink";

type Props = {
  active: AdminActiveEvent | null;
  noneActive: boolean;
  loading: boolean;
  loadError: string | null;
  onRefresh: () => void;
};

export default function AdminActiveEventStrip({
  active,
  noneActive,
  loading,
  loadError,
  onRefresh,
}: Props) {
  return (
    <section className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm text-left md:p-5">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <h2 className="text-base font-semibold text-slate-900">
          현재 활성 행사
        </h2>
        <button
          type="button"
          onClick={onRefresh}
          disabled={loading}
          className="self-start rounded-md border border-slate-300 bg-white px-3 py-1.5 text-sm font-medium text-slate-800 hover:bg-slate-50 disabled:opacity-50 sm:self-auto"
        >
          {loading ? "불러오는 중…" : "활성 행사 새로고침"}
        </button>
      </div>

      <div className="mt-3 rounded-md bg-slate-50 px-3 py-2.5 text-sm text-slate-800">
        {loading ? (
          <span className="text-slate-500">활성 행사 확인 중…</span>
        ) : noneActive ? (
          <span className="text-amber-800">
            현재 활성화된 행사가 없습니다. 행사를 활성화한 뒤 다시 시도하세요.
          </span>
        ) : active ? (
          <div className="space-y-1.5">
            <div>
              <span className="font-medium text-slate-900">행사명: </span>
              {eventDisplayLabel(active.name, active.startAt, active.endAt)}
            </div>
            <div className="text-slate-700 text-xs sm:text-sm">
              <span className="font-medium text-slate-900">유형: </span>
              {eventTypeLabel(active.type)}
            </div>
            <div className="text-slate-700 text-xs sm:text-sm">
              <span className="font-medium text-slate-900">코드: </span>
              {active.urlCode != null && String(active.urlCode).trim() !== ""
                ? String(active.urlCode).trim()
                : "—"}
            </div>
          </div>
        ) : (
          <span className="text-slate-500">
            활성 행사 정보를 표시할 수 없습니다.
          </span>
        )}
      </div>

      {loadError && (
        <p className="mt-3 text-sm text-red-600" role="alert">
          {loadError}
        </p>
      )}
    </section>
  );
}
